"use client";

import { FC } from "react";
import Image from "next/image";
import { Button } from "@workspace/ui/components";
import { cn } from "@workspace/ui/lib/utils";

type MediaToggleButtonProps = {
  type: "audio" | "video";
  enabled: boolean;
  onToggle: () => void;
  size?: "sm" | "lg";
};

const mediaIcons = {
  audio: { on: "/icons/mic.svg", off: "/icons/mic-off.svg" },
  video: { on: "/icons/cam.svg", off: "/icons/cam-off.svg" },
};

export const MediaToggleButton: FC<MediaToggleButtonProps> = ({
  type,
  enabled,
  onToggle,
  size = "lg",
}) => {
  const iconSrc = enabled ? mediaIcons[type].on : mediaIcons[type].off;
  const iconSize = size === "lg" ? 24 : 16;

  return (
    <Button
      variant="p-secondary"
      onClick={onToggle}
      className={cn(
        "rounded-xl border-none",
        size === "lg" ? "size-12.5 p-3.25" : "size-10",
        enabled ? "bg-white" : "bg-[#f07c47] hover:bg-[#f07c47]/80",
      )}
    >
      <Image src={iconSrc} width={iconSize} height={iconSize} alt={type} />
    </Button>
  );
};
